import { render } from "./footer.vue?vue&type=template&id=28883fa4&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=28883fa4&scoped=true&lang=css"

import exportComponent from "E:\\ddemo\\zhongxiaoqi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28883fa4"]])

export default __exports__